module.exports = __webpack_public_path__ + "img/img-scholarshipprogram2@3x.d441703b.jpg";